import axios from "axios";
import { TTP_API_URL } from "Config";

export const getMedias = ({
  token,
  limit,
  offset = 0,
  communityId,
  lng,
  conditions = [],
  search = null
}) => {
  let fields = [
    "*",
    "meta",
    "webPath",
    "title",
    "preview",
    "creator",
    "social",
    "organization"
  ];

  let filter = [
    {
      property: "organization.id",
      operator: "eq",
      value: communityId
    },
    {
      property: "languages",
      operator: "flike",
      value: lng
    }
  ];

  filter = [...filter, ...conditions];

  const allowedMediaTypes = ["IMAGE", "VIDEO", "PPT", "PDF"];

  if (!filter.find(fil => fil.property === "docType")) {
    filter.push({
      property: "docType",
      operator: "in",
      value: allowedMediaTypes
    });
  }

  if (search) {
    //TODO search in other fields
    filter.push({
      property: `title${lng.charAt(0).toUpperCase() + lng.slice(1)}`,
      operator: "like",
      value: search
    });
  }
  filter.push({
    property: "isPrivate",
    operator: "eq",
    value: "0"
  });

  filter.push({
    property: "objectType",
    operator: "in",
    value: [...allowedMediaTypes, "ARTICLE"]
  });

  const sort = [
    {
      property: "createdAt",
      dir: "desc"
    }
  ];

  const requestUrl = `${TTP_API_URL}/media/media`;

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter),
      sort: JSON.stringify(sort),
      fields: fields.join(","),
      limit,
      start: offset
    }
  });
};

export const getMediasByType = ({ token, community, lng }) => {
  let requestUrl = `${TTP_API_URL}/media/media/latest-by-type?lng=${lng}`;
  if (community) {
    requestUrl += `&organizationId=${community.id}`;
  }

  return axios.get(requestUrl, {
    params: {
      access_token: token
    }
  });
};

export const getMediasInTheNews = ({ token, community }) => {
  let requestUrl = `${TTP_API_URL}/media/media`;

  const filter = [
    {
      property: "organization.id",
      operator: "eq",
      value: community.id
    },
    {
      property: "inTheNews",
      operator: "eq",
      value: 1
    }
  ];
  const sort = [
    {
      property: "createdAt",
      dir: "desc"
    }
  ];
  let fields = ["*", "webPath", "preview"];

  return axios.get(requestUrl, {
    params: {
      access_token: token,
      filter: JSON.stringify(filter),
      sort: JSON.stringify(sort),
      fields: fields.join(","),
      limit: 5
    }
  });
};

export const saveMedia = ({
  token,
  lng,
  id,
  community,
  file,
  titleFR,
  titleEN,
  titleNL,
  descriptionFR,
  descriptionEN,
  descriptionNL,
  altFR,
  altEN,
  altNL,
  copyrightFR,
  copyrightEN,
  copyrightNL,
  tags,
  creator,
  taggedUsers,
  isPrivate,
  mediaStatus,
  overrideMainImage = false,
  onProgress,
  docType,
  mask,
  logo = null,
  logoPosition = null,
  logoSize = null,
  width,
  height,
  languages
}) => {
  const requestUrl = `${TTP_API_URL}/media/media`;
  let config = {};
  if (onProgress) {
    config.onUploadProgress = progressEvent => {
      let percentCompleted = Math.floor(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      onProgress(percentCompleted);
    };
  }

  let formData = new FormData();
  formData.append("access_token", token);
  formData.append("organization", community.id);

  if (languages && languages.includes("FR")) {
    formData.append("titleFr", titleFR || file.name);
  }

  if (languages && languages.includes("NL")) {
    formData.append("titleNl", titleNL || file.name);
  }

  if (languages && languages.includes("EN")) {
    formData.append("titleEn", titleEN || file.name);
  }

  formData.append("overrideMainImage", overrideMainImage);
  descriptionFR && formData.append("descriptionFr", descriptionFR);
  descriptionEN && formData.append("descriptionEn", descriptionEN);
  descriptionNL && formData.append("descriptionNl", descriptionNL);
  altFR && formData.append("altFr", altFR);
  altEN && formData.append("altEn", altEN);
  altNL && formData.append("altNl", altNL);
  copyrightFR && formData.append("copyrightFr", copyrightFR);
  copyrightEN && formData.append("copyrightEn", copyrightEN);
  copyrightNL && formData.append("copyrightNl", copyrightNL);
  creator && formData.append("creator", creator.id);
  file && formData.append("file", file);
  docType && formData.append("docType", docType);
  mask && formData.append("mask", mask.id);
  formData.append("isPrivate", isPrivate ? 1 : 0);
  mediaStatus && formData.append("mediaStatus", mediaStatus);
  languages && formData.append("languages", languages.join(","));

  if (logo && logoPosition && logoSize) {
    formData.append("logo", logo.id);
    const x = logoPosition.i * 25;
    const y = logoPosition.j * 25;
    formData.append("logoData", `${x}x${y}_${logoSize}`);
  }

  if (taggedUsers && taggedUsers.length > 0) {
    const ids = taggedUsers.map(user => user.id).join(",");
    formData.append("taggedUsers", ids);
  }

  width && formData.append("width", width);
  height && formData.append("height", height);
  id && formData.append("id", id);

  if (tags && tags.length > 0) {
    // const nameAttr = `name${data.language.charAt(0).toUpperCase() + data.language.slice(1)}`;
    tags.forEach((tag, i) => {
      if (tag.id) {
        formData.append(`tags[${i}][id]`, tag.id);
      } else {
        formData.append(`tags[${i}][nameFr]`, tag["nameFr"] || "");
        formData.append(`tags[${i}][nameEn]`, tag["nameEn"] || "");
        formData.append(`tags[${i}][nameNl]`, tag["nameNl"] || "");
      }
    });
  }

  return axios.post(requestUrl, formData, config);
};



// WEBPACK FOOTER //
// ./src/api/media.js